import { ClipboardState } from "@thkStore/Store/Widgets/Clipboard/ClipboardState";

const CLIPBOARD_KEY_PREFIX = "clipboard_state";

export function setClipboardToStorage(currentState: ClipboardState) {
    const key = `${CLIPBOARD_KEY_PREFIX}`;
    sessionStorage.setItem(key, JSON.stringify(currentState));
}

export function loadClipboardFromStorage(): ClipboardState | null {    
    const key = `${CLIPBOARD_KEY_PREFIX}`;    
    const data = sessionStorage.getItem(key);
    return data ? JSON.parse(data) : null;
}

export function clearClipboardStorage() {    
    const key = `${CLIPBOARD_KEY_PREFIX}`;
    sessionStorage.removeItem(key);
}